/**
 * In-app notification toasts. Anything in the app can fire one — `notify({...})`
 * dispatches a window event that NotificationToastHost renders as a transient
 * pop-up (slide-in, auto-dismiss, with a "View" action that opens the
 * Notification/Activity Center). This is how "an agent finished a task" surfaces
 * to the user while they're using Xavior, without stealing focus.
 */

export const NOTIFICATION_EVENT = 'xavior:notification';

export interface NotificationToastInput {
  /** Stable id (optional) — dedupes re-fires; auto-generated otherwise. */
  id?: string;
  /** Leading badge glyph (emoji). Defaults to a bell. */
  icon?: string;
  /** Who/what it's from, e.g. an agent name. */
  actor?: string;
  /** Headline line (required). */
  title: string;
  /** Optional secondary line. */
  message?: string;
  /** Primary action label. Defaults to "View" (opens the center). */
  actionLabel?: string;
}

/** Fire an in-app notification toast. */
export function notify(input: NotificationToastInput): void {
  if (typeof window === 'undefined' || !input.title) return;
  window.dispatchEvent(new CustomEvent(NOTIFICATION_EVENT, { detail: input }));
}
